module.exports = __webpack_public_path__ + "assets/Omicron.d4bb087b4eb1cea1206af7b36b7a0300.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/packs2x/Omicron.png
// module id = 841
// module chunks = 0